import { render, staticRenderFns } from "./ListEmployers.vue?vue&type=template&id=79527349&"
import script from "./ListEmployers.vue?vue&type=script&lang=js&"
export * from "./ListEmployers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports